// export const environment = {
//     production: false,
//     apiUrl: 'https://qmxuat.qmexpress.biz',  // UAT backend URL
//     imageUrl: 'http://143.198.207.181:5000' // UAT image URL
//     // imageUrl: 'https://qmxuat.qmexpress.biz' // UAT image URL
//   };
  export const environment = {
    production: false,
    apiUrl: 'https://qmxuat.qmexpress.biz',  // UAT backend URL
    imageUrl: 'https://qmxuat.qmexpress.biz' // UAT image URL (proxied through nginx)
  };
  